import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingReduceImageSizeConfig } from '@/data/landingConfig/landingReduceImageSizeConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ReduceImageSize } from './schemaObject';

interface Props {}
const ReduceImageSize: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ReduceImageSize} />
			<LandingTemplate
				data={landingReduceImageSizeConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageCompressor()}
			/>
		</>
	);
};

export default ReduceImageSize;
